import React, { useState, useRef } from 'react';
import defaultAvatar from '../../assets/avt.jpg';
import './AvatarModal.css';

export default function AvatarModal({ currentAvatar, onClose, onUpdated }) {
    const [preview, setPreview] = useState(null);
    const [file,    setFile]    = useState(null);
    const [loading, setLoading] = useState(false);
    const [error,   setError]   = useState('');
    const inputRef = useRef(null);

    const handleFile = (e) => {
        const f = e.target.files[0];
        if (!f) return;
        if (f.size > 2 * 1024 * 1024) { setError('Ảnh tối đa 2MB'); return; }
        if (!f.type.startsWith('image/')) { setError('Chỉ chấp nhận file ảnh'); return; }
        setError('');
        setFile(f);
        setPreview(URL.createObjectURL(f));
    };

    const handleUpload = async () => {
        if (!file) return;
        setLoading(true);
        setError('');
        try {
            const token = localStorage.getItem('accessToken') || '';
            const formData = new FormData();
            formData.append('file', file);
            const res = await fetch('/movies-api/api/v1/users/avatar', {
                method: 'POST',
                headers: token ? { Authorization: `Bearer ${token}` } : {},
                body: formData,
            });
            const data = await res.json();
            if (!res.ok || !data.data) { setError(data.message || 'Upload thất bại'); return; }
            const newUrl = data.data;
            const stored = JSON.parse(localStorage.getItem('USER_LOGIN') || '{}');
            stored.avatarUrl = newUrl;
            localStorage.setItem('USER_LOGIN', JSON.stringify(stored));
            window.dispatchEvent(new CustomEvent('avatarUpdated', { detail: { avatar: newUrl } }));
            onUpdated(newUrl);
            onClose();
        } catch { setError('Lỗi kết nối'); }
        finally { setLoading(false); }
    };

    return (
        <div className="avt-backdrop" onClick={onClose}>
            <div className="avt-modal" onClick={e => e.stopPropagation()}>
                <div className="avt-header">
                    <span>Đổi ảnh đại diện</span>
                    <button className="avt-close" onClick={onClose}>✕</button>
                </div>

                <div className="avt-preview-wrap">
                    <img
                        className="avt-preview"
                        src={preview || currentAvatar || defaultAvatar}
                        alt="avatar"
                    />
                    <button className="avt-pick-btn" onClick={() => inputRef.current?.click()}>
                        Chọn ảnh
                    </button>
                    <input ref={inputRef} type="file" accept="image/*" onChange={handleFile} style={{ display: 'none' }} />
                </div>

                <p className="avt-hint">PNG, JPG, WEBP · Tối đa 2MB</p>

                {error && <p className="avt-error">{error}</p>}

                <div className="avt-actions">
                    <button className="avt-btn avt-btn--ghost" onClick={onClose}>Huỷ</button>
                    <button
                        className="avt-btn avt-btn--primary"
                        onClick={handleUpload}
                        disabled={!file || loading}
                    >
                        {loading ? 'Đang tải...' : 'Lưu ảnh'}
                    </button>
                </div>
            </div>
        </div>
    );
}
